import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-page-command',
  standalone: true,
  imports: [],
  templateUrl: './page-command.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './page-command.component.scss'
})

export class PageCommandComponent {
  name = input<string>();
  text = input<string>();
  icon = input<string>();
  action = input<() => void>(null);
  type = input<PageCommandType>(PageCommandType.Primary);
  requiredPermissions = input<string>('');
  disabled = input<boolean>(false);
}

export enum PageCommandType { 
  Primary = 'Primary', 
  Secondary = 'Secondary',
}

export interface PageCommand {
  name: string;
  text: string;
  icon: string;
  action: () => void;
  type: PageCommandType;
  requiredPermissions: string[];
  disabled: boolean;
}